import { render, staticRenderFns } from "./PlantSp.vue?vue&type=template&id=6b6995d8"
import script from "./PlantSp.vue?vue&type=script&lang=js"
export * from "./PlantSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports